(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTable(table) {
    var triggers = table.querySelectorAll('[data-smelu-cmp-trigger]');

    triggers.forEach(function (btn) {
      var wrap = btn.closest('.smelu-cmp__tip-wrap');
      if (!wrap) return;

      btn.addEventListener('click', function () {
        var isOpen = wrap.classList.contains('is-open');

        // Close all open tooltips in this table
        table.querySelectorAll('.smelu-cmp__tip-wrap.is-open').forEach(function (w) {
          w.classList.remove('is-open');
          w.style.removeProperty('--tip-x-shift');
          var t = w.querySelector('[data-smelu-cmp-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          wrap.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');

          // Boundary-Check: nach dem Öffnen messen ob das Tooltip
          // links/rechts aus dem Viewport ragt — wenn ja per CSS-Variable
          // horizontal shiften damit es komplett sichtbar bleibt.
          requestAnimationFrame(function () {
            var tip = wrap.querySelector('.smelu-cmp__tooltip');
            if (!tip) return;
            var rect = tip.getBoundingClientRect();
            var viewportW = window.innerWidth;
            var safePad = 8;
            var shiftPx = 0;
            if (rect.right > viewportW - safePad) {
              shiftPx = -(rect.right - (viewportW - safePad));
            } else if (rect.left < safePad) {
              shiftPx = safePad - rect.left;
            }
            if (shiftPx !== 0) {
              wrap.style.setProperty('--tip-x-shift', shiftPx + 'px');
            }
          });
        }
      });
    });

    // Click outside closes all
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.smelu-cmp__tip-wrap')) {
        table.querySelectorAll('.smelu-cmp__tip-wrap.is-open').forEach(function (w) {
          w.classList.remove('is-open');
          w.style.removeProperty('--tip-x-shift');
          var t = w.querySelector('[data-smelu-cmp-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Escape key closes focused tooltip
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      table.querySelectorAll('.smelu-cmp__tip-wrap.is-open').forEach(function (w) {
        w.classList.remove('is-open');
        w.style.removeProperty('--tip-x-shift');
        var t = w.querySelector('[data-smelu-cmp-trigger]');
        if (t) {
          t.setAttribute('aria-expanded', 'false');
          t.focus();
        }
      });
    });

    // Status-symbol pulse on first scroll-enter
    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var rows = entry.target.querySelectorAll('[data-anim-child]');
          rows.forEach(function (row, i) {
            setTimeout(function () {
              row.querySelectorAll('.smelu-cmp__status-btn').forEach(function (btn) {
                btn.classList.add('smelu-cmp__status-btn--pulse');
                btn.addEventListener('animationend', function () {
                  btn.classList.remove('smelu-cmp__status-btn--pulse');
                }, { once: true });
              });
            }, i * 80);
          });
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.15 });

      observer.observe(table);
    }
  }

  function init() {
    document.querySelectorAll('[data-smelu-cmp-table]').forEach(initTable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
